<template>
  <button class="menubtn" @click="$emit('clickFunction')">
    <div :class="['menubtn__icon', { open: isMenuOpen || isModalOpen }]">
      <span class="menubtn__icon__line"></span>
      <span class="menubtn__icon__line"></span>
      <span class="menubtn__icon__line"></span>
    </div>
  </button>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      isMenuOpen: "ui/isMenuOpen",
      isModalOpen: "ui/isModalOpen",
    }),
  },
};
</script>

<style lang="scss" scoped>
.menubtn {
  width: toRem($landing-side-WIDTH);
  height: toRem($header-HEIGHT);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: all;
  z-index: 2;

  &__icon {
    width: 1.5625rem;
    height: 1.149rem;
    position: relative;
    transform: rotate(0deg);
    cursor: pointer;

    &__line {
      display: block;
      position: absolute;
      height: 2px;
      width: 100%;
      background: var(--primary-yellow);
      border-radius: 9px;
      transition: 0.25s ease-in-out;
      transform-origin: left center;

      &:nth-child(1) {
        top: 0%;
      }

      &:nth-child(2) {
        top: 50%;
      }

      &:nth-child(3) {
        top: 100%;
      }
    }

    &.open {
      .menubtn__icon__line {
        &:nth-child(1) {
          transform: rotate(45deg);
          top: 0%;
        }

        &:nth-child(2) {
          width: 0%;
          opacity: 0;
        }

        &:nth-child(3) {
          transform: rotate(-45deg);
          top: 100%;
        }
      }
    }
  }
}

.mobile {
  .menubtn {
    width: $header-width-mobile;
    height: 100%;
  }
}

.tablet {
  .menubtn {
    width: $header-width-tablet;
    margin-top: 1vh;
    height: 100%;
  }
}
</style>
